import React, {useCallback, useMemo} from "react";
import {Box, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import Dialog from "../../base/dialog";
import Button from "../../base/button/button";
import {BizFormAnswerForm} from "../../../../packages/biz-form";

const AnswerFormDialog = ({
                              open,
                              onClose,
                              formId,
                              formTitle,
                              responseId,
                              externalUserId,
                              newResponse = false,
                              titleMode,
                              api,
                              onSuccess,
                              fileInfo,
                          }) => {
    const {t} = useTranslation("dialogs", {keyPrefix: "answerFormDialog"});

    const resolvedTitleMode = titleMode ?? (newResponse ? "fill" : "view");

    const dialogTitle = useMemo(() => {
        if (formTitle) {
            return formTitle;
        }
        switch (resolvedTitleMode) {
            case "fill":
                return t("fillTitle");
            case "resubmit":
                return t("resubmitTitle");
            case "view":
            default:
                return t("viewTitle");
        }
    }, [formTitle, resolvedTitleMode, t]);

    const canRenderForm = open && formId && (responseId || newResponse);

    /**
     * Handles the completion of form submission by invoking the onSuccess callback and closing the dialog.
     * @type {(function(): void)|*}
     */
    const onSubmitted = useCallback(() => {
        onSuccess?.();
        onClose();
    }, [onClose, onSuccess]);

    return (
        <Dialog
            open={open}
            setOpen={(v) => !v && onClose()}
            maxWidth="md"
            fullWidth
            scroll="paper"
            className="bound-dialog"
        >
            <DialogTitle fontWeight={600} component="div">
                <Typography variant="h6" fontWeight={600} sx={{padding: 2}}>
                    {dialogTitle}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{display: "flex", flexDirection: "column", minHeight: "50vh"}}>
                    {canRenderForm && (
                        <BizFormAnswerForm
                            fileInfo={fileInfo}
                            apiClient={api}
                            formId={formId}
                            formResponseId={responseId}
                            externalUserId={externalUserId}
                            onSubmitted={onSubmitted}
                            newResponse={newResponse}
                            showResetButton={newResponse}
                            showClearButton={newResponse}
                            showSubmitButton={newResponse}
                        />
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: 0, display: "flex", justifyContent: "space-between"}}>
                <Button variant="dialog" color="primary" onClick={onClose} borderRadius="0 8px 0 0">
                    {t("close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AnswerFormDialog;
